import React, { useContext, useEffect, useState } from "react";
import { Menu, type MenuProps, theme, Modal, message, Tag } from "antd"; // Added Modal, message, Tag
import Sider from "antd/es/layout/Sider";
import { RiBrainLine, RiHome2Fill, RiInfinityFill, RiPercentLine, RiSettingsFill } from "react-icons/ri";
import { useNavigate, useParams, useSearchParams } from "react-router-dom"; // Added useSearchParams
import { Gi3DMeeple, GiAbstract004, GiDivingDagger, GiRomanToga } from "react-icons/gi";
import { AuthContext } from "../../../../config/AuthContext";
import { GrConfigure } from "react-icons/gr";
import { IoDocumentsOutline } from "react-icons/io5";
import { LuListTodo } from "react-icons/lu";
import { PiExam } from "react-icons/pi";
import { TbMeeple } from "react-icons/tb";
import { BiTrash, BiPlus } from "react-icons/bi"; // Added Icons
import NouDocumentModal from "../NouDocumentModal"; // Added Modal
import { DeleteDocument } from "../../../../dao/abp/DeleteDocument"; // Added DAO

interface Props {
    currentVal: number,
    setPantalla: (value: number, isSprint: boolean, sprint: string) => void;
    setPantalLaDocs?: (value: number, isSprint: boolean, sprint: string) => void;
    sprints: any[];
    docs?: any[];
    refresh?: () => void;
}

const AppSiderProjectesId = (props: Props) => {
    const [pantalla, setPantalla] = useState<any>(props.currentVal);
    const { id_projecte } = useParams(); // Get project ID
    const [searchParams] = useSearchParams();
    const [showNewDoc, setShowNewDoc] = useState(false);

    const handleDeleteDoc = async (id: string) => {
        Modal.confirm({
            title: 'Eliminar document',
            content: 'Estàs segur que vols eliminar aquest document?',
            onOk: async () => {
                await DeleteDocument(id);
                message.success('Document eliminat');
                if (props.refresh) props.refresh();
            }
        });
    };

    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        console.log("DOCS: " + JSON.stringify(props.docs));
        document.title = 'Web Dubtes';
    }, []);

    useEffect(() => {
        const docId = searchParams.get('doc');
        if (docId && props.docs && props.docs.length > 0) {
            const docIndex = props.docs.findIndex(d => String(d.id) === String(docId));
            if (docIndex !== -1 && props.setPantalLaDocs) {
                props.setPantalLaDocs(docIndex, true, docId);
                setPantalla("doc-" + docIndex);
            }
        }
    }, [searchParams, props.docs]);

    const titles: string[] = ['Grups', 'Documentació', 'Gestió de Tasques', 'Validació', 'Configuració'];
    const titlesRoot: string[] = ['Grups', 'Documentació', 'Professorat', 'Gestió de Tasques', 'Validació', 'Configuració'];
    const titlesAlu: string[] = ['Grups', 'Documentació', 'Tasques', 'Validació'];
    const indexes: number[] = [0, 1, 3, 5, 6];
    const indexesRoot: number[] = [0, 1, 4, 3, 5, 6];
    const indexAlu: number[] = [0, 1, 2, 5];

    const items2: MenuProps['items'] = [TbMeeple, IoDocumentsOutline, LuListTodo, PiExam, GrConfigure].map(
        (icon, index) => {
            const key = Number(index + 1);

            let children: any[] | undefined = undefined;

            if (titles[index] === 'Documentació') {
                children = (props.docs || []).map((doc, docIndex) => ({
                    key: `doc-${docIndex}`,
                    label: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 120 }}>{doc.nom}</span>
                            {(user.tipus === "1" || user.tipus === "0") && (
                                <BiTrash
                                    onClick={(e: React.MouseEvent) => {
                                        e.stopPropagation();
                                        handleDeleteDoc(doc.id);
                                    }}
                                    style={{ color: 'red', cursor: 'pointer' }}
                                />
                            )}
                        </div>
                    ),
                    onClick: () => {
                        if (props.setPantalLaDocs) {
                            props.setPantalLaDocs(docIndex, true, doc.id);
                        }
                        setPantalla("doc-" + docIndex);
                    }
                }));

                // Add "Afegir Document" item at the end of valid docs
                if (user.tipus === "1" || user.tipus === "0") {
                    children.push({
                        key: 'add-doc',
                        icon: <BiPlus />,
                        label: 'Afegir Document',
                        onClick: () => setShowNewDoc(true)
                    });
                }
            }

            return {
                key: key,
                icon: React.createElement(icon),
                label: titles[index],
                onClick: () => {
                    if (titles[index] !== 'Documentació') {
                        setPantalla(indexes[index]);
                        props.setPantalla(indexes[index], false, '');
                    }
                },
                children: children
            };
        },
    );
    const itemsRoot: MenuProps['items'] = [TbMeeple, IoDocumentsOutline, LuListTodo, GiRomanToga, PiExam, GrConfigure].map(
        (icon, index) => {
            const key = Number(index + 1);

            let children: any[] | undefined = undefined;

            if (titlesRoot[index] === 'Documentació') {
                children = (props.docs || []).map((doc, docIndex) => ({
                    key: `doc-${docIndex}`,
                    label: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 120 }}>{doc.nom}</span>
                            {(user.tipus === "1" || user.tipus === "0") && (
                                <BiTrash
                                    onClick={(e: React.MouseEvent) => {
                                        e.stopPropagation();
                                        handleDeleteDoc(doc.id);
                                    }}
                                    style={{ color: 'red', cursor: 'pointer' }}
                                />
                            )}
                        </div>
                    ),
                    onClick: () => {
                        if (props.setPantalLaDocs) {
                            props.setPantalLaDocs(docIndex, true, doc.id);
                        }
                        setPantalla("doc-" + docIndex);
                    }
                }));

                // Add "Afegir Document" item
                children.push({
                    key: 'add-doc',
                    icon: <BiPlus />,
                    label: 'Afegir Document',
                    onClick: () => setShowNewDoc(true)
                });
            }

            return {
                key: key,
                icon: React.createElement(icon),
                label: titlesRoot[index],
                onClick: () => {
                    if (titlesRoot[index] !== 'Documentació') {
                        setPantalla(indexesRoot[index]);
                        props.setPantalla(indexesRoot[index], false, '');
                    }
                },
                children: children
            };
        },
    );
    const items2Alu: MenuProps['items'] = [TbMeeple, IoDocumentsOutline, LuListTodo, PiExam].map(
        (icon, index) => {
            const key = Number(index + 1);

            let children: any[] | undefined = undefined;

            if (titlesAlu[index] === 'Tasques') {
                children = (props.sprints || [])
                    .filter(sprint => {
                        // Admin sees all
                        if (user.tipus === "1" || user.tipus === "0") return true;

                        // Students don't see future sprints
                        if (sprint.data_inici) {
                            const start = new Date(sprint.data_inici);
                            if (new Date() < start) return false;
                        }
                        return true;
                    })
                    .map((sprint, sprintIndex) => {
                        const now = new Date();

                        // Helper to safely parse SQL-like dates (YYYY-MM-DD HH:mm:ss) to ISO (YYYY-MM-DDTHH:mm:ss)
                        const parseDate = (dateStr: string) => {
                            if (!dateStr) return null;
                            // Si ya tiene T, es ISO. Si tiene espacio, reemplazar por T.
                            const safeStr = dateStr.replace(' ', 'T');
                            const d = new Date(safeStr);
                            return isNaN(d.getTime()) ? null : d;
                        };

                        const start = parseDate(sprint.data_inici);
                        const end = parseDate(sprint.data_final);

                        //console.log(`Sprint Debug ${sprint.id}:`, { start, end, rawStart: sprint.data_inici, rawEnd: sprint.data_final, estado: sprint.estado });

                        let statusColor = 'default';
                        let statusText = 'No iniciat';

                        if (start && end) {
                            if (now < start) {
                                statusColor = 'default';
                                statusText = 'No iniciat';
                            } else if (now >= start && now <= end) {
                                statusColor = 'success';
                                statusText = 'En curs';
                            } else {
                                statusColor = 'error';
                                statusText = 'Tancat';
                            }
                        } else {
                            // Date fallback using explicit status if dates are missing/invalid
                            if (sprint.estado === 'cerrado') {
                                statusColor = 'error';
                                statusText = 'Tancat';
                            } else if (sprint.estado === 'abierto') {
                                statusColor = 'success';
                                statusText = 'En curs';
                            }
                        }

                        // Determine label content
                        const label = (
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2', padding: '4px 0' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>Sprint {sprint.numero}: {sprint.label}</span>
                                    <Tag color={statusColor} style={{ margin: 0, fontSize: '10px', lineHeight: '14px' }}>{statusText}</Tag>
                                </div>
                                {start && end && (
                                    <span style={{ fontSize: '10px', color: '#888' }}>
                                        {start.toLocaleDateString()} - {end.toLocaleDateString()}
                                    </span>
                                )}
                            </div>
                        );

                        return {
                            key: `sp-${sprint.id}`, // Use ID for unique key if possible, or Index
                            label: label,
                            onClick: () => {
                                props.setPantalla(sprintIndex, true, sprint.id);
                                setPantalla("sp-" + sprintIndex);
                            }
                        };
                    });
            } else if (titlesAlu[index] === 'Documentació') {
                children = (props.docs || []).map((doc, docIndex) => ({
                    key: `doc-${docIndex}`,
                    label: doc.nom, // 👈 usar el atributo "nom"
                    onClick: () => {
                        if (props.setPantalLaDocs) {
                            props.setPantalLaDocs(docIndex, true, doc.id);
                        }
                        setPantalla("doc-" + docIndex);
                    }
                }));
            }

            return {
                key: key,
                icon: React.createElement(icon),
                label: titlesAlu[index],
                onClick: () => {
                    if (titlesAlu[index] !== 'Tasques' && titlesAlu[index] !== 'Documentació') {
                        setPantalla(indexAlu[index]);
                        props.setPantalla(indexAlu[index], false, '');
                    }
                },
                children: children
            };
        },
    );

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                selectedKeys={typeof pantalla === 'string' ? [pantalla] : [(pantalla + 1) + ""]}
                defaultSelectedKeys={typeof pantalla === 'string' ? [pantalla] : [(pantalla + 1) + ""]}
                style={{ height: '100%' }}
                items={user.tipus === "1" ? items2 : (user.tipus === "0" ? itemsRoot : items2Alu)}
            />
            {showNewDoc && (
                <NouDocumentModal
                    visible={showNewDoc}
                    onClose={(refresh) => {
                        setShowNewDoc(false);
                        if (refresh && props.refresh) props.refresh();
                    }}
                    idProjecte={id_projecte + ""}
                />
            )}
        </Sider>
    );
}

export default AppSiderProjectesId;